module.exports = __webpack_public_path__ + "static/media/general.5466d3ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/general.png
// module id = 1581
// module chunks = 0